import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import { extractKybReportDetails } from "src/modules/3rd-party-management/helpers/kybReports";
import { buildDnbExportSections } from "../../helpers/dnbExport";
import { KeyValueTable } from "../../shared";
import ReportSectionBlock from "./ReportSectionBlock";

const DunBradstreetReport = ({ report }) => {
    const details = extractKybReportDetails(report);
    const sections = buildDnbExportSections(details);

    if (!details?.company || sections.length === 0) {
        return (
            <KeyValueTable
                rows={[]}
                emptyMessage="No Dun & Bradstreet data available"
            />
        );
    }

    return (
        <View>
            {sections.map((section, index) => (
                <ReportSectionBlock
                    key={`${section.title}-${index}`}
                    section={section}
                    breakBefore={index > 0 && index % 3 === 0}
                />
            ))}
        </View>
    );
};

export default withNamespaces()(DunBradstreetReport);
